
import http from './http';

//登录
export function login(data: { username: string; password: string }) {
  return http.post('/login/doLogin', data);
}
//注册
export function register(data: { username: string; password: string;password_confirm: string; mobile: string }) {
  return http.post('/login/mreg', data);
}
//修改密码
/**
 * 
 * @param data 
 * old_password	string			
旧密码  
new_password	string			
新密码  
new_password_confirm	string			
确认密码  
 * @returns 
 */
export function getLoginMreg(data: { old_password: string; new_password: string;new_password_confirm: string; }) {
  return http.post('login/mreset', data);
}
